import { render, staticRenderFns } from "./formGroupSecondView.vue?vue&type=template&id=6c0464df&scoped=true&"
import script from "./formGroupSecondView.vue?vue&type=script&lang=js&"
export * from "./formGroupSecondView.vue?vue&type=script&lang=js&"
import style0 from "./formGroupSecondView.vue?vue&type=style&index=0&id=6c0464df&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c0464df",
  null
  
)

export default component.exports